import $store from '@/store/index';
import { staticUrl, staticPath } from '@/units/config';
import { append_thumbnail_params } from './resize';

// 添加cdn域名前缀
export const _cdn = (url = '', cdnurl = '') => {
  if (!url) return '';
  if (url.indexOf('http') === 0) {
    return url;
  }
  if (cdnurl === '') {
    cdnurl = $store.getters.appInfo.cdnurl;
  }
  if (url[0] == '/') {
    return cdnurl + url;
  } else {
    return cdnurl + '/' + url;
  }
};

// 对象存储自动剪裁缩略图
export const _thumb = (url = '', params) => {
  url = _cdn(url);
  return append_thumbnail_params(url, params);
};

// 静态资源地址
export const _static = (url = '', staticurl = '', staticpath = true) => {
  if (staticurl === '') {
    staticurl = staticUrl;
  }
  if (staticurl !== 'local') {
    if (staticpath && url.indexOf('http') !== 0) {
      if (staticPath[staticPath.length - 1] == '/' && url[0] == '/') {
        url = staticPath.substring(0, staticPath.length - 1) + url;
      } else {
        url = staticPath + url;
      }
    }
    url = _cdn(url, staticurl);
  }
  return url;
};

// css背景图片地址
export const _css = (url = '', staticurl = '', staticpath = true) => {
  url = _static(url, staticurl, staticpath);
  // #ifdef APP-PLUS
  if (staticurl === 'local') {
    url = plus.io.convertLocalFileSystemURL(url);
  }
  // #endif
  return `url(${url})`;
};

export default {
  cdn: _cdn,
  static: _static,
  css: _css,
  thumb: _thumb,
};
